<template>
  <div v-if="dataLoaded" class="row switcher language-switch">
    <ul class="language-switch-list">
      <li
          class="language-switch-item"
          v-for="item in languageInfo.items"
          :key="item.id">
        <span
            class="language"
            :class="[item.languageCode,{'selected': item.selected}]"
            :data-code="item.localeCode"
            @click="changeLanguage(item.localeCode)">
          {{ item.label }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import netsetNode from 'netsetNode';

export default {
  data() {
    return {
      languageInfo: {},
      dataLoaded: false
    }
  },
  methods: {
    changeLanguage(localeCode) {
      netsetNode.call('/nodeapi/change_locale', {localeCode: localeCode}).then(function () {
        location.reload()
      });
    }
  },
  mounted() {
    const vm = this;
    netsetNode.call('/nodeapi/language_info').then(function (response) {
      if (response){
        vm.languageInfo = response;
        vm.dataLoaded = true;
      }
    }).catch(function (error) {})
  },
}
</script>

<style scoped lang="scss">
@import "~@stylesheets/sass/base/_mixins.scss";

.language-switch {
  text-align: center;
  display: inline-block;

  &-list {
    display: inline-block;
    list-style: none;
    margin-left: 0;
  }

  &-item {
    cursor: pointer;
    @include breakpoint("medium-large") {
      display: inline-block;
      margin-right: 10px;
      &::after {
        content: "|";
        margin-left: 10px;
      }
      &:last-of-type::after {
        content: "";
        margin-left: 0;
      }
    }
  }

  .selected {
    font-weight: bold;
  }
}
</style>

